
  <!-- content begin -->
  <div id="content" class="no-bottom no-top">
    <div id="top"></div>


  <!-- section begin -->
  <section id="subheader" class="text-light" data-bgimage="url(assets/images/background/10.jpg)" data-stellar-background-ratio=".2" style="background: url(assets/images/background/16.jpg) 0% 0px / cover; " >
    <div class="overlay-bg t50" style="background: rgba(30, 30, 30, .5)">

        <div class="container">
            <div class="row">
                <div class="col-md-12">
                    <h1>About the post</h1>
                </div>
            </div>
        </div>

    </div>

</section>
<!-- section close -->



<div class="row notifi_main ">
  <div class="col-md-12">
<h2> Graphic Designer  </h2>


  </div>
</div>


    <!-- section begin -->
    <section id="section-services">
        <div class="container">

            <div class="row align-items-center">
    <div class="col-md-12">
      <div class="row sequence">



         

        <!-- feature box begin -->
        <div class="col-md-12 mb40 sq-item wow sq-item wow">
          <div class="feature-box style-2 left">
            <i class="fa fa-graduation-cap"></i>
            <div class="text para_cls">
              <h3>Qualification: </h3>
              <p> <span class="step_no">1</span>Any Master degree or a related field.</p>
			  <!-- <p> <span class="step_no">2</span>Conversational skills, coupled with communication skills in English language preferable</p>  -->
			  
			

            </div>
          </div>
        </div>
        <!-- feature box close -->


 <!-- feature box begin -->
        <div class="col-md-12 mb40 sq-item wow sq-item wow">
          <div class="feature-box style-2 left">
            <i class="fa fa-graduation-cap"></i>
            <div class="text para_cls">
              <h3>Experience: </h3>
              <p> <span class="step_no">1</span>Minimum of 0-2 years of experience as a Graphic Design or Social Media design</p>
			  <p> <span class="step_no">2</span>Experience designing Posters & Banners</p>
			  <p> <span class="step_no">3</span>Develop Thumbline for Youtube , Creating #Tag for youtube Content</p>
              <p> <span class="step_no">4</span>Content Creation for Instagram & Social media</p>
              <p> <span class="step_no">5</span>Video Editing for educational Content</p>
              <!-- <p> <span class="step_no">6</span></p>
              <p> <span class="step_no">7</span></p>
              <p> <span class="step_no">8</span></p> -->
              <!-- <p> <span class="step_no">9</span></p> -->
              <!-- <p> <span class="step_no">10</span></p> -->
              <!-- <p> <span class="step_no">11</span></p> -->
            </div>
          </div>
        </div>
        <!-- feature box close -->


 <!-- feature box begin -->
        <div class="col-md-12 mb40 sq-item wow sq-item wow">
          <div class="feature-box style-2 left">
            <i class="fa fa-globe"></i>
            <div class="text para_cls">
              <h3>Responsibilities: </h3>
              <br><h3>Creative Design & Visual Communication</h3>
               <p><span class="step_no">1</span>Design a wide variety of materials including brochures, posters, banners, infographics, logos, icons, flyers, advertisements, and presentations</p>
               <p><span class="step_no">2</span>Conceptualize and execute creative ideas based on client briefs or internal requirements</p>
               <p><span class="step_no">3</span>Create branding assets such as logos, typography systems, and brand guidelines.</p>
               <p><span class="step_no">4</span>Develop layouts and design templates for print and digital usage, ensuring aesthetic balance and visual appeal.</p>
               <br><h3>Digital & Social Media Design</h3>
               <p><span class="step_no">1</span>Design creative content for social media platforms (Instagram, Facebook, LinkedIn, YouTube thumbnails, etc.).</p>
               <p><span class="step_no">2</span>Prepare web graphics, email templates, and digital advertisements</p>
               <p><span class="step_no">3</span>Ensure optimized visual content for responsive display on different devices (mobile, tablet, desktop).Develop visually appealing graphics, layouts, and illustrations for websites, social media, presentations, brochures, posters, packaging, and other marketing materials.</p>
               <p><span class="step_no">4</span>Collaborate with teams including marketing, content writers, video editors, and developers to translate concepts into impactful designs</p>
               <!-- <p><span class="step_no">5</span></p>
               <p><span class="step_no">6</span></p> -->

            </div>
          </div>
        </div>
        <!-- feature box close -->



  <!-- feature box begin -->
  <div class="col-md-12 feature-box mb40 sq-item wow">
    <div class="feature-box style-2 left">
      <i class="fa fa-money"></i>
      <div class="text para_cls">
        <h3>Remuneration:</h3>
        <p> <span class="step_no">1</span> Rs. 27,000/-  </p>
		<!-- <p> <span class="step_no">2</span> Rs. 45,000/- per month (consolidated pay) for 4+ Experience from which standard TDS will be deducted at source. Not entitled to any other allowance or benefits.  </p> -->

      </div>
    </div>
  </div>
  <!-- feature box close -->

<!-- feature box begin -->
    <div class="col-md-12 feature-box mb40 sq-item wow">
        <div class="feature-box style-2 left">
          <i class="fa fa-cogs"></i>
          <div class="text para_cls">
            <h3>Skills & Requirements:</h3>
                <p><span class="step_no">1</span>Proficiency in design tools such as Adobe PStrong proficiency in Adobe Creative Suite (Photoshop, Illustrator, InDesign); CorelDRAW or Canva is an added advantage.</p>
                <p><span class="step_no">2</span>Excellent sense of layout, composition, color harmony, and typography</p>
                <p><span class="step_no">3</span>Attention to detail and ability to deliver high-quality work under tight deadlines</p>
                <p><span class="step_no">4</span>Creative thinking and ability to solve visual communication challenges</p>
                <p><span class="step_no">5</span>Portfolio demonstrating a strong understanding of design fundamentals and diversity in projects.</p>
                <!-- <p><span class="step_no">6</span>Excellent attention to detail and a keen eye for aesthetics</p>
                <p><span class="step_no">7</span>Strong problem-solving skills and the ability to work under pressure.</p>
                <p><span class="step_no">8</span>Ability to work both independently and as part of a collaborative team</p> -->
                <!-- <p><span class="step_no">9</span></p>
                <p><span class="step_no">10</span></p> -->
                
            
          </div>
        </div>
      </div>
      <!-- feature box close -->

  <!-- feature box begin -->
  <div class="col-md-12 feature-box mb40 sq-item wow">
    <div class="feature-box style-2 left">
      <i class="fa fa-calendar"></i>
      <div class="text para_cls">
        <h3>Last Date:</h3>
        <p style="color: red;"><b> Last date for Applying Online 03th July 2025 </b> </p>
      </div>
    </div>
  </div>
  <!-- feature box close -->

  <!-- feature box begin -->
  <!-- <div class="col-md-12 feature-box mb40 sq-item wow">
    <div class="feature-box style-2 left">
      <i class="fa fa-cogs"></i>
      <div class="text para_cls">
        <h3>Job Description:</h3>
		
 
<p> <span class="step_no">1</span>Conceptualize and design Motion graphics/2D & 3D animation and illustrations for developing educational videos.</p>
<p> <span class="step_no">2</span>Perform story boarding, editing, composting, rendering and other post-processes.</p>
<p> <span class="step_no">3</span>Understand the unique needs of each subject and develop 2D animation/Motion graphic using vectors and 3D models.</p>
<p> <span class="step_no">4</span>Discuss briefs with subject matter experts, produce visually appealing motion graphics, 2D & 3D animations and illustrations.</p>
<p> <span class="step_no">5</span>Specialization and/or expertise in classical animation, character animation, motion graphics, dynamic, typography and others.</p>
<p> <span class="step_no">6</span>Manage projects from start to finish across a wide range of media, meeting deadlines and working with constraints efficiently.</p>
<p> <span class="step_no">7</span>Demonstrated ability and working knowledge of Adobe Creative Suite and video editing tools.</p>
<p> <span class="step_no">8</span>Coordinating with subject matter experts and conduct video shoot for developing educational videos.</p>
<p> <span class="step_no">9</span>Work on designing digital and print mediums.</p>


      </div>
    </div>
  </div> -->
  <!-- feature box close -->

    

          <!-- feature box begin -->
    <!-- <div class="col-md-12 feature-box mb40 sq-item wow">
        <div class="feature-box style-2 left">
          <i class="fa fa-cogs"></i>
          <div class="text para_cls">
            <h3>Period of Contract:</h3>
            <p><span class="step_no">1</span>The appointment to the post will be purely on contract basis initially for a period of one year, further extendable subject to satisfactory performance and requirement of services for another year.</p>

            <p><span class="step_no">2</span> The performance of the consultant will be reviewed every year and the contract shall be extended or discontinued (as the case may be) depending on the performance. The decision of  NIMI shall be final in this regard. </p>

            <p><span class="step_no">3</span> The decision of  NIMI shall be final in this regard. </p>

    
          </div>
        </div>
      </div> -->
      <!-- feature box close -->


    
    <!-- feature box begin -->
  <div class="col-md-12 feature-box mb40 sq-item wow">
    <div class="feature-box style-2 left">
      <i class="fa fa-globe"></i>
      <div class="text para_cls">
        <h3>Locations</h3>
       		<p><span class="step_no">1</span>Chennai </p>





      </div>
    </div>
  </div>
  <!-- feature box close -->

  <!-- feature box begin -->
  <!-- <div class="col-md-12 feature-box mb40 sq-item wow">
    <div class="feature-box style-2 left">
      <i class="fa fa-globe"></i>
      <div class="text para_cls">
        <h3>Selection Process:</h3>
        <p><span class="step_no">1</span>Selection will be done on the basis of performance in the personal interview by a selection committee. </p>
		<p><span class="step_no">2</span>Only shortlisted candidates will be called for the interview.</p>
		<p><span class="step_no">3</span>No TA/DA will be paid for attending the interview.</p>
<p><span class="step_no">4</span>At the time of the interview, the candidates shall produce their original certificates for verification. </p>

      </div>
    </div>
  </div> -->
  <!-- feature box close -->

     <!-- feature box begin -->
  <!-- <div class="col-md-12 feature-box mb40 sq-item wow">
    <div class="feature-box style-2 left">
      <i class="fa fa-globe"></i>
      <div class="text para_cls">
        <h3>Attendance and leave policy:</h3>
        <p><span class="step_no">1</span>The working hours will be the same as for NIMI.</p>
		<p><span class="step_no">2</span>No extra remuneration shall be paid for working beyond office hours or on Saturdays/Sundays/gazetted holidays.</p>
<p><span class="step_no">3</span>Compulsory leave in such cases shall be at the discretion of the competent authority.</p>

      </div>
    </div>
  </div> -->
  <!-- feature box close -->

    <!-- feature box begin -->
  <!-- <div class="col-md-12 feature-box mb40 sq-item wow">
    <div class="feature-box style-2 left">
      <i class="fa fa-globe"></i>
      <div class="text para_cls">
        <h3>Confidentiality and secrecy :</h3>
        <p><span class="step_no">1</span>The consultant maintain confidentiality and will not divulge any information gathered during the period of engagement with the NIMI to any person who is not authorised to know the same. </p>



      </div>
    </div>
  </div> -->
  <!-- feature box close -->

   <!-- feature box begin -->
  <div class="col-md-12 feature-box mb40 sq-item wow">
    <div class="feature-box style-2 left">
      <i class="fa fa-globe"></i>
      <div class="text para_cls">
        <h3>Documents for attending the Test and Interview :</h3>
        <p><span class="step_no">1</span>2 copies of passport size photographs</p>
		<p><span class="step_no">2</span>Original and self attested copies of educational certificates</p>
		<p><span class="step_no">3</span>Original and self attested copies of  Caste certificate  and Aadhar card </p>
		<p><span class="step_no">4</span>Original  and self attested copies of Experience certificates </p>



      </div>
    </div>
  </div>
  <!-- feature box close -->


<!--
  <div class="col-md-12 feature-box mb40 sq-item wow" style="text-align: center;">
    <a href="http://nimiprojects.in/recruitment/register.php" target="_blank" class="btn-custom scroll-to">Apply Now</a>
</div> -->


  <div class="container big_padd">








      </div>


    </div>
    <!-- content close -->




    <style>
      #section-intro{
        background-image: url(assets/images/background/niminew.jpg);
    background-size: cover;
    background-position: 0% 0px;
    height: 80vh !important;
      }
      .notifi_main{
        text-align: center;
        padding: 40px 0px;
      }

      .notifi_main h2{
        border-bottom: 6px solid #F56B55;
    width: fit-content;
    margin: 0 auto;
    padding: 0px 30px;
      }
      .notifi_main .descrip_cls{
        padding: 5px 0px;
    font-weight: 500;
    font-size: 21px;
      }

      .overlay-bg.t50{
        background: rgba(30, 30, 30, .1);
      }

      table{
      width: 100%;
      margin-top: 10px;
    }
    th, td{
      padding: 10px;
    }
    thead{
      background-color: #F56B55;
      color: #fff;
    }
    tr:nth-child(odd){
      background-color: #eee;
    }
    .step_no{
      left: 80px;
    height: 30px;
    width: 30px;
    background-color: #F56B55;
    border-radius: 50%;
    display: inline-block;
    font-size: 18px;
    text-align: center;
    color: #fff;
    margin-right: 10px;
    position: absolute;
    }

    .para_cls p{
      padding-left: 35px;
    }
    .num_marks{
      text-align: center;
    }
    .last_tr{
      background-color: #F56B55 !important;
      color: #fff;
    }
    .notifi_main_table h2{

    width: fit-content;
    margin: 0 auto;
    padding: 50px 30px 10px;
    font-size: 23px;

    }
    .para_main_notify{
      padding: 20px 0px;
    width: 50%;
    margin: 0 auto;
    }
  #section-services{
      padding: 0px !important;
    }
    </style>








